module.exports = __webpack_public_path__ + "img/LF_16-TS.332c3f5a.svg";